<template>
  <div class="mt-3 mb-0">
    <v-card flat outlined tile>
      <v-card-text class="pb-0 pt-0">
        <v-row align="center">
          <v-col cols="12" md="4" class="py-0">
            <v-row align="center">
              <v-col md="4" cols="12">
                <v-img
                  height="100"
                  width="100"
                  :src="
                    client.logo
                      ? client.logo
                      : require(`@/static/images/organization/default-logo.jpg`)
                  "
                ></v-img>
              </v-col>
              <v-col md="8" cols="12">
                <v-tooltip bottom class="mx-1">
                  <template v-slot:activator="{ on }">
                    <div
                      v-on="on"
                      class="body-1 blue--text text--darken-4 font-weight-black pointer"
                      @click="
                        $router.push({
                          name: 'clients-clientslug',
                          params: { clientSlug: client.slug }
                        })
                      "
                    >
                      {{ truncate(client.name, 18) }}
                      <span class="is_blocked px-2 float-right" v-if="client.is_blocked">Blocked!</span>  
                    </div>
                    
                  </template>
                  <span>
                    {{ client.name }}
                  </span>
                </v-tooltip>
                <div
                  class="mt-1 font-weight-bold blue-grey--text text--darken-3"
                >
                  {{ $getProp(client, "b2b.industry_name") }}
                </div>
                <div class="caption mt-1">
                  <span class="grey--text text--darken-2">Client Value :</span>
                  <span
                    class="ml-1 font-weight-bold blue-grey--text text--darken-3"
                  >
                    {{ client.client_value || "N/A" }}
                  </span>

                  <v-icon
                    v-if="client.client_value"
                    x-small
                    v-text="$getIcon('mdiCheckboxBlankCircle')"
                    :color="clientValueColor[client.client_value]"
                  >
                  </v-icon>
                </div>
                <div class="mt-1 blue-grey--text caption text--darken-3">
                  Profile Completeness: <span class="green--text">20%</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8" class="py-0 pl-5">
            <select-contact-person
              :key="refreshContact"
              :client="clientDetail"
              @triggerLogForm="$emit('triggerLogForm', $event)"
            ></select-contact-person>
          </v-col>
        </v-row>
      </v-card-text> </v-card
    ><v-card flat tile>
      <v-card-text class="py-2 grey lighten-4">
        <v-row>
          <v-col md="4" cols="12">
            <div class="d-flex align-center">
              <v-icon small v-text="$getIcon('mdiCart')" class="mr-2"> </v-icon>
              <div class="caption grey--text text--darken-2">
                Last Service / Stage
              </div>
            </div>
            <div class="d-flex align-center">
              <div class="font-weight-bold blue-grey--text text--darken-3 mx-6">
                {{ client.latest_service_taken_name || "N/A" }}
              </div>
            </div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="caption grey--text text--darken-2">
              <v-icon
                small
                v-text="$getIcon('mdiInformationOutline')"
                class="mr-2"
              >
              </v-icon
              >Opportunities
            </div>
            <div class="font-weight-bold blue-grey--text text--darken-3 ml-6">
              NRs.
              {{ (client.total_opportunity_amount || 0).toLocaleString() }}
            </div>
          </v-col>
          <v-col md="2" cols="6">
            <div class="caption grey--text text--darken-2">
              <v-icon
                small
                v-text="$getIcon('mdiInformationOutline')"
                class="mr-2"
              >
              </v-icon
              >Leads
            </div>
            <div class="font-weight-bold blue-grey--text text--darken-3 ml-6">
              NRs.
              {{ (client.total_lead_amount || 0).toLocaleString() }}
            </div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="caption grey--text text--darken-2">
              <v-icon
                small
                v-text="$getIcon('mdiInformationOutline')"
                class="mr-2"
              >
              </v-icon
              >Deals
            </div>
            <div class="font-weight-bold blue-grey--text text--darken-3 ml-6">
              NRs.
              {{ (client.total_deal_amount || 0).toLocaleString() }}
            </div>
          </v-col>
          <v-col md="2" cols="6">
            <div class="caption grey--text text--darken-2">
              <v-icon
                small
                v-text="$getIcon('mdiInformationOutline')"
                class="mr-2"
              >
              </v-icon
              >Lost
            </div>
            <div
              v-if="
                client.total_opportunity_amount &&
                  client.total_deal_amount &&
                  client.total_opportunity_amount - client.total_deal_amount >=
                    0
              "
              class="font-weight-bold blue-grey--text text--darken-3 ml-6"
            >
              NRs.
              {{
                (
                  client.total_opportunity_amount - client.total_deal_amount
                ).toLocaleString()
              }}
            </div>
            <div
              v-else
              class="font-weight-bold blue-grey--text text--darken-3 ml-6"
            >
              NRs.0
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import SelectContactPerson from "./selectContactPerson";
export default {
  props: {
    clientDetail: {
      type: Object,
      required: true
    },
    refreshContact: {
      type: Number,
      default: 1
    }
  },
  components: { SelectContactPerson },
  watch: {
    clientDetail: {
      handler() {
        this.fetchClientDetail();
      },
      immediate: true
    }
  },
  data() {
    return {
      client: {},
      clientValueColor: {
        Low: "red",
        Mid: "amber",
        High: "green"
      }
    };
  },
  methods: {
    fetchClientDetail() {
      this.$axios
        .$get(`/api/v1/crm/clients/${this.clientDetail.slug}/`)
        .then(response => {
          this.client = response;
        });
    },
    truncate(text, length, suffix) {
      if (!text) return "";
      let truncatedText = "";
      suffix = suffix || "...";
      if (text.length > length) {
        truncatedText = text.substring(0, length) + suffix;
      } else {
        truncatedText = text.substring(0, length);
      }
      return truncatedText;
    }
  }
};
</script>

<style scoped>
  .is_blocked{
    font-size: 10px;
    color: red;
  }
</style>
